import common from '../common';
import commonGame from '../commonGame';

const _fillAt = Symbol('_fillAt');
const _floodFill = Symbol('_floodFill');
const _isPixelToFill = Symbol('_isPixelToFill');
const _paintPixel = Symbol('_paintPixel');
const _updateFillAnimMask = Symbol('_updateFillAnimMask');
const _onColour_Changed = Symbol('_onColour_Changed');
const _onFillLayer_Click = Symbol('_onFillLayer_Click');

export default class FillLayer extends PIXI.Container{
	constructor() {
		super();
		// Enumerators.
		this.STATE = {
			IDLE: 0,
			FILL_ANIM: 1
		};


		// Attributes.
		this._state = this.STATE.IDLE;
		this._paletteItem = null;

		this._colour_c2d = null;
		this._colourCode_c2d = null;
		this._fillAnim_c2d = null;

		this._colourContext = null;
		this._colourCodeContext = null;
		this._fillAnimContext = null;

		this._curColour = null;

		this._outlineImage = new Image();

		// Buffers.
		this._fillAnimLayerData = null;
		this._colourLayerData = null; // Contains the pixel colour for the painted areas (no outline) as they are seen on the screen.
		this._outlineLayerData = null; // Contains the pixel colour for the outline. Its content is not displayed.
		this._colourCodeLayerData = null; // Contains the pixel colour CODE for the painted areas (no outline). Its content is not displayed.
		// The flood fill algorithm implemented uses plain colours, so to make it compatible with textures it is necessary to use this auxiliary buffer.

		// Sprites.
		this._colourLayerSprite = null;
		this._fillAnimLayerSprite = null;
		this._outlineLayerSprite = null;
		this._fillAnimMask = null;

		// Input.
		this._lastInputGlobalPosition = new PIXI.Point();

		// Fill animation.
		this._fillAnimRadius = 0;
		this._fillAnimMaxDeltaX = 0;
		this._fillAnimMaxDeltaY = 0;
		this._textureStartPixelPos = -1; // The pixel position (as an index in colourLayerData ) where the selected texture is applied.

		this._drawPS = null;
	}

	init() {
		// Canvas.
		this._colour_c2d = document.createElement('canvas');
		this._colour_c2d.width = common.game.canvas.WIDTH;
		this._colour_c2d.height = common.game.canvas.HEIGHT;

		this._colourCode_c2d = document.createElement('canvas');
		this._colourCode_c2d.width = common.game.canvas.WIDTH;
		this._colourCode_c2d.height = common.game.canvas.HEIGHT;

		this._fillAnim_c2d = document.createElement('canvas');
		this._fillAnim_c2d.width = common.game.canvas.WIDTH;
		this._fillAnim_c2d.height = common.game.canvas.HEIGHT;

		// Context.
		this._colourContext = this._colour_c2d.getContext('2d');
		this._colourCodeContext = this._colourCode_c2d.getContext('2d');
		this._fillAnimContext = this._fillAnim_c2d.getContext('2d');

		// Layers.
		// Fill colour.
		this._colourLayerSprite = new PIXI.Sprite(PIXI.Texture.fromCanvas(this._colour_c2d));
		this._colourLayerSprite.anchor = new PIXI.Point(0.5, 0.5);
		this._colourLayerSprite.interactive = true;
		this._colourLayerSprite.click = this._colourLayerSprite.touchend = this[_onFillLayer_Click].bind(this);
		this.addChild(this._colourLayerSprite);
		// Fill animation.
		this._fillAnimMask = new PIXI.Graphics();
		this.addChild(this._fillAnimMask);
		this._fillAnimLayerSprite = new PIXI.Sprite(PIXI.Texture.fromCanvas(this._fillAnim_c2d));
		this._fillAnimLayerSprite.anchor = new PIXI.Point(0.5, 0.5);
		this._fillAnimLayerSprite.mask = this._fillAnimMask;
		this.addChild(this._fillAnimLayerSprite);
		// Outline.
		//const outlineTexture = PIXI.Texture.fromImage(`assets/images/outlines/${common.config.theme}/` + (commonGame.selectedGallery == commonGame.GALLERY_ID_DRAW_IT ? 'draw_it/' : 'colour_it/') + commonGame.selectedImageId + '.png');
		this._outlineLayerSprite = new PIXI.Sprite(P3.assets.texture(commonGame.selectImage));
		const croppedOutlineTexture = new PIXI.Texture(this._outlineLayerSprite.texture, new PIXI.Rectangle(this._outlineLayerSprite.width * 0.5 - common.game.canvas.WIDTH * 0.5, this._outlineLayerSprite.height * 0.5 - common.game.canvas.HEIGHT * 0.5, common.game.canvas.WIDTH, common.game.canvas.HEIGHT));
		this._outlineLayerSprite.setTexture(croppedOutlineTexture);

		//this._outlineLayerSprite = new PIXI.Sprite( P3.assets.texture( commonGame.selectedImageId ) );
		this._outlineLayerSprite.anchor = new PIXI.Point(0.5, 0.5);
		this.addChild(this._outlineLayerSprite);

		// Buffers.
		this._colourContext.clearRect(0, 0, this._colour_c2d.width, this._colour_c2d.height);
		// Fill animation.
		this._fillAnimLayerData = this._fillAnimContext.getImageData(0, 0, this._fillAnim_c2d.width, this._fillAnim_c2d.height);
		// Colour.
		this._colourLayerData = this._colourContext.getImageData(0, 0, this._colour_c2d.width, this._colour_c2d.height);
		// Colour code.
		this._colourCodeLayerData = this._colourContext.getImageData(0, 0, this._colour_c2d.width, this._colour_c2d.height);
		// Outline.
		//this._outlineImage.src = `assets/images/outlines/${common.config.theme}/` + ( commonGame.selectedGallery === commonGame.GALLERY_ID_DRAW_IT ? 'draw_it/' : 'colour_it/image_' ) + commonGame.selectedImageId + '.png';
		this._outlineImage.src = this._outlineLayerSprite.texture.baseTexture.imageUrl;
		this._colourContext.drawImage(
			this._outlineImage,
			this._colourLayerSprite.width * 0.5 - this._outlineImage.width * 0.5 * this._outlineLayerSprite.scale.x,
			this._colourLayerSprite.height * 0.5 - this._outlineImage.height * 0.5 * this._outlineLayerSprite.scale.y,
			this._outlineImage.width * this._outlineLayerSprite.scale.x,
			this._outlineImage.height * this._outlineLayerSprite.scale.y);
		this._outlineLayerData = this._colourContext.getImageData(0, 0, this._colour_c2d.width, this._colour_c2d.height);

		// TODO: ???
		this._colourContext.clearRect(0, 0, this._colourContext.canvas.width, this._colourContext.canvas.height);

		// Initial empty canvas .
		this._colourContext.clearRect(0, 0, this._colour_c2d.width, this._colour_c2d.height);

		// Default colour.
		this[_onColour_Changed](common.gameConfig.palettePanel.pages[0][0], 0, 0);

		// Vfx.
		this._drawPS = new PIXI.particles.Emitter(this._outlineLayerSprite, [P3.assets.texture('particle_paintfill')], P3.assets.json('fill_ps'));
		this._drawPS.emit = false;
		this._drawPS.emitterLifetime = 0.1;

		// Listen to HUD controls.
		common.game.scene.palettePanel.signals.onColourChanged.add(this[_onColour_Changed], this);
	}

	destroy(options) {
		super.destroy();
	}

	update() {
		this._drawPS && this._drawPS.update(P3.Ticker.dt);
	}

	setEnabled(isEnabled) {
		this._colourLayerSprite.interactive = isEnabled;
	}

	setLayerData(data, colourCodeData) {
		this._colourCodeLayerData = colourCodeData;
		this._colourCodeContext.putImageData(colourCodeData, 0, 0);
		this._colourLayerData = data;
		this._colourContext.putImageData(data, 0, 0);
		this._colourLayerSprite.texture.update();
	}

	clear(){
		this._colourContext.clearRect(0, 0, this._colour_c2d.width, this._colour_c2d.height);
		this._colourLayerData = this._colourContext.getImageData(0, 0, this._colour_c2d.width, this._colour_c2d.height);
		this._colourCodeLayerData = this._colourContext.getImageData(0, 0, this._colour_c2d.width, this._colour_c2d.height);
		this._colourLayerSprite.texture.update();
	}

	onContext_Changed(){
		this._colourLayerSprite.texture.update();
	}

	updateContextData(){
		this._colourCodeLayerData = this._colourCodeContext.getImageData(0, 0, this._colourCode_c2d.width, this._colourCode_c2d.height);
		this._colourLayerData = this._colourContext.getImageData(0, 0, this._colour_c2d.width, this._colour_c2d.height);
	}

	[_fillAt](startX, startY) {
		// Check same colour.
		const pixelIndex = (startY * this._colour_c2d.width + startX) * 4;
		const r = this._colourCodeLayerData.data[pixelIndex];
		const g = this._colourCodeLayerData.data[pixelIndex + 1];
		const b = this._colourCodeLayerData.data[pixelIndex + 2];
		let a = this._colourCodeLayerData.data[pixelIndex + 3];

		if (r === this._curColour.colourCode.r
			&& g === this._curColour.colourCode.g
			&& b === this._curColour.colourCode.b)
			return;

		// Check outline.
		a = this._outlineLayerData.data[pixelIndex + 3];
		if (a > 0)
			return;

		// Check dynamic outline.
		a = common.game.canvas.drawLayer.dynOutlineData.data[pixelIndex + 3];
		if (a > 0)
			return;

		// Flood fill.
		this._textureStartPixelPos = pixelIndex;
		this[_floodFill](startX, startY);

		// Redraw.
		this._colourContext.clearRect(0, 0, this._colourContext.canvas.width, this._colourContext.canvas.height);
		this._colourContext.putImageData(this._colourLayerData, 0, 0);

		// Filling animation.
		const targetRadius = Math.sqrt(Math.pow(this._fillAnimMaxDeltaX, 2) + Math.pow(this._fillAnimMaxDeltaY, 2));

		new P3.utils.TWEEN.Tween(this, this.tweens)
		    .to({
				_fillAnimRadius: targetRadius
		    }, targetRadius / 0.6)
		    .easing(P3.utils.TWEEN.Easing.Linear.None)
		    .onComplete(()=>{
				this[_updateFillAnimMask]();

				this._fillAnimMaxDeltaX = 0;
				this._fillAnimMaxDeltaY = 0;
				this._fillAnimRadius = 0;
				this._state = this.STATE.IDLE;

				// Update layers and buffers.
				this._colourLayerSprite.texture.update();

				this._fillAnimMask.clear();

				this._fillAnimContext.clearRect(0, 0, this._fillAnim_c2d.width, this._fillAnim_c2d.height);
				this._fillAnimLayerData = this._fillAnimContext.getImageData(0, 0, this._fillAnim_c2d.width, this._fillAnim_c2d.height);
				this._fillAnimLayerSprite.texture.update();
		    })
			.onUpdate(()=>{
				this[_updateFillAnimMask]();
			})
		    .start();

		this._fillAnimContext.putImageData(this._fillAnimLayerData, 0, 0);
		this._fillAnimLayerSprite.texture.update();

		this._state = this.STATE.FILL_ANIM;
	}

	[_floodFill](startX, startY) {
		let newPos,
			x,
			y,
			pixelIndex,
			reachLeft,
			reachRight,
			drawingBoundLeft = 0,
			drawingBoundTop = 0,
			drawingBoundRight = common.game.canvas.WIDTH - 1,
			drawingBoundBottom = common.game.canvas.HEIGHT - 1,
			pixelStack = [[startX, startY]];

		while (pixelStack.length) {
			newPos = pixelStack.pop();
			x = newPos[0];
			y = newPos[1];

			//console.log( "dx = " + dx );
			const dx = x - startX;
			let dy = y - startY;

			// Update limits for filling animation.
			if (Math.abs(dy) > this._fillAnimMaxDeltaY)
				this._fillAnimMaxDeltaY = Math.abs(dy);
			if (Math.abs(dx) > this._fillAnimMaxDeltaX)
				this._fillAnimMaxDeltaX = Math.abs(dx);

			// Get current pixel index inside image data.
			pixelIndex = ( y * this._colour_c2d.width + x ) * 4;

			// Go up as long as the colour matches and are inside the canvas.
			while (y >= drawingBoundTop && this[_isPixelToFill](pixelIndex)) {
				y -= 1;
				pixelIndex -= this._colour_c2d.width * 4;
			}

			pixelIndex += this._colour_c2d.width * 4;
			y += 1;
			reachLeft = false;
			reachRight = false;

			// Go down as long as the colour matches and in inside the canvas.
			while (y <= drawingBoundBottom && this[_isPixelToFill](pixelIndex)) {
				this[_paintPixel](pixelIndex);

				if (x > drawingBoundLeft) {
					if (this[_isPixelToFill](pixelIndex - 4)) {
						if (!reachLeft) {
							// Add pixel to stack
							pixelStack.push([x - 1, y]);
							reachLeft = true;
						}
					}
					else if (reachLeft)
						reachLeft = false;
				}

				if (x < drawingBoundRight) {
					if (this[_isPixelToFill](pixelIndex + 4)) {
						if (!reachRight) {
							// Add pixel to stack
							pixelStack.push([x + 1, y]);
							reachRight = true;
						}
					}
					else if (reachRight)
						reachRight = false;
				}

				y += 1;
				pixelIndex += this._colour_c2d.width * 4;

				// Update limits for filling animation.
				dy = y - startY;
				if (Math.abs(dy) > this._fillAnimMaxDeltaY)
					this._fillAnimMaxDeltaY = Math.abs(dy);
			}
		}
	}

	[_isPixelToFill](pixelIndex) {
		let result = true;

		// If given pixel is not part of the outline.
		let r = this._outlineLayerData.data[pixelIndex];
		let g = this._outlineLayerData.data[pixelIndex + 1];
		let b = this._outlineLayerData.data[pixelIndex + 2];
		let a = this._outlineLayerData.data[pixelIndex + 3];

		// TODO: Adjust tolerance as necessary.
		result = a <= 255 * 0.5;

		// If current pixel doesn't match the new colour.
		if (result) {
			r = this._colourCodeLayerData.data[pixelIndex];
			g = this._colourCodeLayerData.data[pixelIndex + 1];
			b = this._colourCodeLayerData.data[pixelIndex + 2];

			result = r !== this._curColour.colourCode.r
				|| g !== this._curColour.colourCode.g
				|| b !== this._curColour.colourCode.b;
		}

		// TEST: DYN_OUT:
		// If current pixel is not part of the dynamic outline.
		if (result) {
			a = common.game.canvas.drawLayer.dynOutlineData.data[pixelIndex + 3];
			// TODO: Adjust tolerance as necessary.
			result = a < 255;
		}

		return result;
	}

	[_paintPixel](pixelIndex) {
		// Find pixel colour.
		let r, g, b, a;
		if (this._curColour.isTexture) {
			// pixelIndex is not in canvas coordinates, but image data coordinates! Divide by 4 ( r + g + b + a ) to make the conversion.
			const dy = Math.floor(pixelIndex / 4 / this._colour_c2d.width) - Math.floor(this._textureStartPixelPos / 4 / this._colour_c2d.width);
			const dx = Math.floor(pixelIndex / 4 % this._colour_c2d.width) - Math.floor(this._textureStartPixelPos / 4 % this._colour_c2d.width);

			let textureY = dy % this._curColour.data.height;
			if (textureY < 0)
				textureY += this._curColour.data.height;
			let textureX = dx % this._curColour.data.height;
			if (textureX < 0)
				textureX += this._curColour.data.height;
			const basePixelPos = (this._curColour.data.height * textureY + textureX) * 4;

			//console.log( "dx,dy = " + dx + " :: " + dy );

			r = this._curColour.data.data[basePixelPos];
			g = this._curColour.data.data[basePixelPos + 1];
			b = this._curColour.data.data[basePixelPos + 2];
			a = this._curColour.data.data[basePixelPos + 3] !== undefined ? this._curColour.data.data[basePixelPos + 3] : 255;
		}
		else {
			r = this._curColour.r;
			g = this._curColour.g;
			b = this._curColour.b;
			a = this._curColour.a !== undefined ? this._curColour.a : 255;
		}

		// Buffers.
		// Colour.
		this._colourLayerData.data[pixelIndex] = r;
		this._colourLayerData.data[pixelIndex + 1] = g;
		this._colourLayerData.data[pixelIndex + 2] = b;
		this._colourLayerData.data[pixelIndex + 3] = a;
		// Filling.
		this._fillAnimLayerData.data[pixelIndex] = r;
		this._fillAnimLayerData.data[pixelIndex + 1] = g;
		this._fillAnimLayerData.data[pixelIndex + 2] = b;
		this._fillAnimLayerData.data[pixelIndex + 3] = a;
		// Colour code.
		this._colourCodeLayerData.data[pixelIndex] = this._curColour.colourCode.r;
		this._colourCodeLayerData.data[pixelIndex + 1] = this._curColour.colourCode.g;
		this._colourCodeLayerData.data[pixelIndex + 2] = this._curColour.colourCode.b;
		this._colourCodeLayerData.data[pixelIndex + 3] = 255;
	}

	[_updateFillAnimMask](){
		this._fillAnimMask.clear();
		this._fillAnimMask.beginFill();
		this._fillAnimMask.drawCircle(this._lastInputGlobalPosition.x, this._lastInputGlobalPosition.y, this._fillAnimRadius);
		this._fillAnimMask.endFill();
	}

	[_onColour_Changed](selection, pageIndex, itemIndex) {
		this._paletteItem = selection;
		if (selection.indexOf('#') === 0) {
			// Colour.
			const rgbColour = common.hexToRgb(selection);

			this._curColour =
				{
					r: rgbColour.r,
					g: rgbColour.g,
					b: rgbColour.b,
					isTexture: false,
					colourCode: {r: pageIndex, g: itemIndex, b: 1} // { r: 0, g: 0, b: 0 } is reserved to represent no colour code, so make sure to not use it! That's why b: 1.
				};
		}
		else {
			// Texture.
			const texture = P3.assets.texture(selection);
			const frame = texture.frame;
			var canvas = document.createElement('canvas');
			canvas.width = frame.width;
			canvas.height = frame.height;
			const context = canvas.getContext('2d');
			context.drawImage(
				texture.baseTexture.source,
				frame.x * common.main.assetRes,
				frame.y * common.main.assetRes,
				frame.width * common.main.assetRes,
				frame.height * common.main.assetRes,
				0, 0,
				frame.width, frame.height
			);

			this._curColour = {
				data: context.getImageData(0, 0, canvas.width, canvas.height),
				isTexture: true,
				colourCode: {r: pageIndex, g: itemIndex, b: 1} // { r: 0, g: 0, b: 0 } is reserved to represent no colour code, so make sure to not use it! That's why b: 1.
			};
		}
	};

	[_onFillLayer_Click](mouseData) {
		if (this._state === this.STATE.FILL_ANIM) return;

		// Undo manager.
		this._colourCodeContext.putImageData(this._colourCodeLayerData, 0, 0);
		common.game.undoManager.save();


		// Use canvas' left-top corner as origin.
		const localCoordsPosition = mouseData.data.getLocalPosition(this._colourLayerSprite);
		const ctxCoordPosition = new PIXI.Point();
		ctxCoordPosition.x = Math.floor(localCoordsPosition.x + common.game.canvas.WIDTH * 0.5);
		ctxCoordPosition.y = Math.floor(localCoordsPosition.y + common.game.canvas.HEIGHT * 0.5);
		//console.log( localCoordsPosition.x + " :: " + localCoordsPosition.y );

		this[_fillAt](Math.floor(ctxCoordPosition.x), Math.floor(ctxCoordPosition.y));

		this._lastInputGlobalPosition = new PIXI.Point(
			mouseData.data.global.x - common.game.scene.x - common.game.canvas.x,
			mouseData.data.global.y - common.game.canvas.y);

		// Vfx.
		let rgbColour = {r: 255, g: 255, b: 255};
		if (this._paletteItem.indexOf('#') === 0)
			rgbColour = common.hexToRgb(this._paletteItem);
		this._drawPS.startColor = [rgbColour.r, rgbColour.g, rgbColour.b];
		this._drawPS.endColor = this._drawPS.startColor;
		this._drawPS.spawnPos = new PIXI.Point(localCoordsPosition.x, localCoordsPosition.y);
		this._drawPS.emit = true;

		// Sfx.
		P3.audio.playSound('sfx_tool_paintpot_fill_use_02');

		// Tutorial.
		common.game.scene.addTutorialEvent(commonGame.TUT_EVENT.CANVAS_DRAWN);
	}

	get colourContext(){
		return this._colourContext;
	}

	get colourCodeContext(){
		return this._colourCodeContext;
	}

	get state(){
		return this._state;
	}

	get paletteItem(){
		return this._paletteItem;
	}
}